export default __webpack_public_path__ + "static/media/netuitive.5c99f3f4.svg";